import {
  LOGIN,
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  LOGOUT,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE,
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_FAILURE,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
} from "../types";

export const login = (payload) => ({
  type: LOGIN,
  payload,
});
export const loginSuccess = (payload) => ({
  type: LOGIN_SUCCESS,
  payload,
});
export const loginFailure = (payload) => ({
  type: LOGIN_FAILURE,
  payload,
});

export const logout = (payload) => ({
  type: LOGOUT,
  payload,
});
export const logoutSuccess = (payload) => ({
  type: LOGOUT_SUCCESS,
  payload,
});
export const logoutFailure = (payload) => ({
  type: LOGOUT_FAILURE,
  payload,
});

export const forgetPassword = (payload) => ({
  type: FORGET_PASSWORD,
  payload,
});
export const forgetPasswordSuccess = (payload) => ({
  type: FORGET_PASSWORD_SUCCESS,
  payload,
});
export const forgetPasswordFailure = (payload) => ({
  type: FORGET_PASSWORD_FAILURE,
  payload,
});

export const resetPassword = (payload) => ({
  type: RESET_PASSWORD,
  payload,
});
export const resetPasswordSuccess = (payload) => ({
  type: RESET_PASSWORD_SUCCESS,
  payload,
});
export const resetPasswordFailure = (payload) => ({
  type: RESET_PASSWORD_FAILURE,
  payload,
});